// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3DboM","selected":"Chip_selected__3EZ_J"};